module.exports = __webpack_public_path__ + "static/media/profile-picture-338w.1d20657c.webp";